import React from 'react';
import { Field } from 'redux-form';
import CheckBoxField from 'forms/shared/fields/checkbox'

const AgreementFields = () => (
  <>
    <h3 className="text-2xl py-4">FlySpaces Agreement</h3>
    <p className="mb-4">Your signed contract:</p>
    <Field
      type="checkbox"
      name="accept"
      groupClassName="w-full"
      labelClassName="text-sm text-gray-700"
      label="I accept and agree to the terms in this agreement from FlySpaces"
      inputClassName=""
      inputErrorClassName="border-action-danger"
      errorClassName="text-red-500 text-xs italic"
      component={CheckBoxField}
    />
  </>
);

export default AgreementFields;
